"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _HubAI = require("@insided/shared/modules/HubAI");

var _contentType = require("@insided/shared/utils/contentType");

var _ReplyBody = _interopRequireDefault(require("./ReplyBody"));

var _TopicFooter = _interopRequireDefault(require("../../shared/TopicFooter"));

var _TopicHeader = _interopRequireDefault(require("../../shared/TopicHeader"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _ReportContentModal = _interopRequireDefault(require("../../Post/ReportContentModal"));

var _axios = _interopRequireDefault(require("axios"));

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

var _permissions = require("@insided/deprecated-preact-components/utils/permissions");

var _Editor = require("../../shared/Editor");

var _Attachments = _interopRequireDefault(require("../../V2/Shared/Attachments"));

var _common = require("@insided/shared/utils/common");

var _globals = require("@insided/shared/utils/globals");

var _menuOptions = require("../../shared/TopicHeader/menuOptions");

var _classnames = _interopRequireDefault(require("classnames"));

var _MarkAsSpamModal = _interopRequireDefault(require("../../Post/MarkAsSpamModal"));

var _TrashModal = _interopRequireDefault(require("../../Post/TrashModal"));

var _topicService = require("../../services/topicService");

var _topicService2 = require("@insided/shared/services/topicService");

var _utils = require("../../utils");

var _expandCollapseReplies = require("../utils/expandCollapseReplies");

var _MarkAsNotSpamModal = _interopRequireDefault(require("../../Post/MarkAsNotSpamModal"));

var _ResolveModal = _interopRequireDefault(require("../../Post/ResolveModal"));

var _SubtleButton = _interopRequireDefault(require("@insided/shared/uikit/SubtleButton"));

var _CheckCircleOutline = _interopRequireDefault(require("@insided/destination/icons/CheckCircleOutline"));

var _CheckCircleOffOutline = _interopRequireDefault(require("@insided/destination/icons/CheckCircleOffOutline"));

var _Highlight = _interopRequireDefault(require("@insided/destination/icons/Highlight"));

var _HighlightOff = _interopRequireDefault(require("@insided/destination/icons/HighlightOff"));

var _PinOutline = _interopRequireDefault(require("@insided/destination/icons/PinOutline"));

var _PinOffOutline = _interopRequireDefault(require("@insided/destination/icons/PinOffOutline"));

var _CopyLink = _interopRequireDefault(require("@insided/destination/icons/CopyLink"));

var _Edit = _interopRequireDefault(require("@insided/destination/icons/Edit"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _Profile = _interopRequireDefault(require("../../V2/Shared/Profile"));

var _IpDetails = _interopRequireDefault(require("../../V2/Shared/IpDetails"));

var _NotifyAuthor = _interopRequireDefault(require("../../V2/Shared/NotifyAuthor"));

var _ConfigContext = require("@insided/shared/services/ConfigContext");

var _Moderation = require("@insided/shared/modules/Moderation");

var _MoveReplyModal = _interopRequireDefault(require("../../Post/MoveReplyModal"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Reply = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Reply, _Component);

  var _super = _createSuper(Reply);

  function Reply() {
    var _this$props$reply$att;

    var _this;

    (0, _classCallCheck2.default)(this, Reply);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "config", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      alert: undefined,
      showReportContentModal: false,
      showReportContentResolveModal: false,
      isBestAnswerClicked: false,
      showEditor: false,
      isReplyEditorOpen: false,
      pendingQuote: undefined,
      showSpamModal: false,
      showTrashModal: false,
      showPromoteToNewTopicModal: false,
      isReplyHighlighted: _this.props.reply.highlighted || false,
      isReplyPending: _this.props.reply.pendingApproval || false,
      updatedReplyContent: _this.props.translatedReplyContent,
      updatedAttachments: (_this$props$reply$att = _this.props.reply.attachments) !== null && _this$props$reply$att !== void 0 ? _this$props$reply$att : [],
      isHovered: false,
      showMoveReplyModal: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseEnter", function () {
      _this.setState({
        isHovered: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseLeave", function () {
      _this.setState({
        isHovered: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleEditClick", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$props, isPostTranslated, onDisplayOriginal;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, isPostTranslated = _this$props.isPostTranslated, onDisplayOriginal = _this$props.onDisplayOriginal;

              if (!(isPostTranslated && onDisplayOriginal)) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return onDisplayOriginal();

            case 4:
              _this.setState({
                showEditor: true
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleReplyClick", function () {
      var includeQuote = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$props2 = _this.props,
          reply = _this$props2.reply,
          authors = _this$props2.authors,
          onToggleReplies = _this$props2.onToggleReplies,
          isExpanded = _this$props2.isExpanded;
      var authorId = reply.authorId,
          content = reply.content;
      var authorInfo = authorId && authors ? authors[authorId] : null;
      var pendingQuote = includeQuote && authorInfo ? {
        username: authorInfo.name,
        content: content
      } : undefined;

      _this.setState({
        isReplyEditorOpen: true,
        pendingQuote: pendingQuote
      }, function () {
        // Scroll to the editor when it opens
        if (!isExpanded) {
          onToggleReplies === null || onToggleReplies === void 0 ? void 0 : onToggleReplies();
        }

        var editorElement = document.querySelector("#threaded-reply-editor-".concat(_this.props.reply.id));

        if (editorElement) {
          editorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleEditorInstanceReady", function () {
      var pendingQuote = _this.state.pendingQuote;

      if (pendingQuote) {
        (0, _globals.publish)('quote', pendingQuote);

        _this.setState({
          pendingQuote: undefined
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCancel", function (_ref2) {
      var isEditReply = _ref2.isEditReply;

      if (isEditReply) {
        _this.setState({
          showEditor: false
        });
      } else {
        _this.setState({
          isReplyEditorOpen: false,
          pendingQuote: undefined
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSuccess", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(isEditReply, content, attachments) {
        var _this$props3, onNestedReplyAdded, reply, contentType, _this$props3$depthLev, depthLevel, parentOfCurrentReply, parentIdToRefresh;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!isEditReply) {
                  _context2.next = 4;
                  break;
                }

                _this.setState({
                  showEditor: false,
                  updatedReplyContent: content !== null && content !== void 0 ? content : _this.props.reply.content,
                  updatedAttachments: attachments !== null && attachments !== void 0 ? attachments : _this.props.reply.attachments
                });

                _context2.next = 13;
                break;

              case 4:
                _this$props3 = _this.props, onNestedReplyAdded = _this$props3.onNestedReplyAdded, reply = _this$props3.reply, contentType = _this$props3.contentType, _this$props3$depthLev = _this$props3.depthLevel, depthLevel = _this$props3$depthLev === void 0 ? 1 : _this$props3$depthLev, parentOfCurrentReply = _this$props3.parentReplyId;

                if (!onNestedReplyAdded) {
                  _context2.next = 12;
                  break;
                }

                parentIdToRefresh = depthLevel === _expandCollapseReplies.MAX_DEPTH ? parentOfCurrentReply : reply.id;
                _context2.next = 9;
                return onNestedReplyAdded(parentIdToRefresh, contentType);

              case 9:
                _this.setState({
                  isReplyEditorOpen: false
                });

                _context2.next = 13;
                break;

              case 12:
                globalThis.location.reload();

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x, _x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderEditor", function (_ref4) {
      var _this$props$hasNested;

      var isEditReply = _ref4.isEditReply;
      var _this$props4 = _this.props,
          reply = _this$props4.reply,
          currentUser = _this$props4.currentUser,
          authors = _this$props4.authors,
          topic = _this$props4.topic,
          contentType = _this$props4.contentType,
          disableFileAttachments = _this$props4.disableFileAttachments,
          _this$props4$depthLev = _this$props4.depthLevel,
          depthLevel = _this$props4$depthLev === void 0 ? 1 : _this$props4$depthLev,
          _this$props4$isLastCh = _this$props4.isLastChild,
          isLastChild = _this$props4$isLastCh === void 0 ? false : _this$props4$isLastCh;
      var _this$state = _this.state,
          updatedReplyContent = _this$state.updatedReplyContent,
          updatedAttachments = _this$state.updatedAttachments;
      var privateReplyId = reply.id;
      var topicPrivateId = topic.id;
      var parentOfCurrentReply = _this.props.parentReplyId;
      var author = authors ? authors[reply.authorId] : null;
      var isAfterLevel3LastChild = depthLevel === 3 && isLastChild;
      var hasNestedReplies = (_this$props$hasNested = _this.props.hasNestedRepliesInThread) !== null && _this$props$hasNested !== void 0 ? _this$props$hasNested : false;
      var parentIdForNewReply;

      if (isEditReply) {
        parentIdForNewReply = null;
      } else if (depthLevel === _expandCollapseReplies.MAX_DEPTH) {
        parentIdForNewReply = Number(parentOfCurrentReply);
      } else {
        parentIdForNewReply = Number(privateReplyId);
      }

      var editorWrapperClass = isEditReply ? (0, _classnames.default)('post__content', 'post__edit', 'qa-topic-post-edit') : (0, _classnames.default)('threaded-reply-editor', "level-".concat(depthLevel), {
        'editor-after-level-3-last-child': isAfterLevel3LastChild,
        'has-nested-replies': hasNestedReplies,
        'no-nested-replies': !hasNestedReplies
      });
      var _this$props$displayEx = _this.props.displayExtendedActions,
          displayExtendedActions = _this$props$displayEx === void 0 ? false : _this$props$displayEx; // Use plain text for control (displayExtendedActions=true), translation key for destination

      var placeholder = displayExtendedActions ? 'Leave a reply...' : 'threaded.replies.editor.placeholder';
      var shouldAddMention = depthLevel >= 3 && author && !isEditReply;
      return (0, _preact.h)("div", {
        id: isEditReply ? undefined : "threaded-reply-editor-".concat(privateReplyId),
        "data-qa": isEditReply ? undefined : 'threaded-reply-editor',
        className: editorWrapperClass
      }, (0, _preact.h)(_Editor.Editor, {
        isOpen: true,
        contentType: contentType,
        content: isEditReply ? updatedReplyContent : '',
        disableFileAttachments: disableFileAttachments,
        parentTopicId: Number(topicPrivateId),
        replyId: isEditReply ? Number(privateReplyId) : null,
        parentReplyId: parentIdForNewReply,
        onCancel: function onCancel() {
          return _this.handleCancel({
            isEditReply: isEditReply
          });
        },
        onSuccess: /*#__PURE__*/function () {
          var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(content, attachments) {
            return _regenerator.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    return _context3.abrupt("return", _this.handleSuccess(isEditReply, content, attachments));

                  case 1:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x4, _x5) {
            return _ref5.apply(this, arguments);
          };
        }(),
        mentionTargetReplyAuthor: function mentionTargetReplyAuthor() {
          if (!shouldAddMention) return;
          (0, _globals.publish)('mention', {
            id: String(author.id),
            username: "@".concat(author.name)
          });
        },
        attachments: isEditReply ? updatedAttachments : undefined,
        currentUser: currentUser,
        onInstanceReady: _this.handleEditorInstanceReady,
        redirect: !isEditReply && !parentIdForNewReply,
        placeholder: placeholder,
        isControl: displayExtendedActions
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleShowAlert", function (type, message) {
      _this.setState({
        alert: {
          type: type,
          message: typeof message === 'string' ? (0, _preact.h)(_phrase.default, {
            p: message
          }) : message !== null && message !== void 0 ? message : (0, _preact.h)(_phrase.default, {
            p: "topic_view.reported_content_modal.error"
          })
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleReportedContentModal", function (show) {
      _this.setState({
        showReportContentModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleReportedContentResolveModal", function (show) {
      _this.setState({
        showReportContentResolveModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showSpamModal", function (show) {
      _this.setState({
        showSpamModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showTrashModal", function (show) {
      _this.setState({
        showTrashModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showPromoteToNewTopicModal", function (show) {
      _this.setState({
        showPromoteToNewTopicModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onHighlightReply", function () {
      _this.setState(function (prevState) {
        return {
          isReplyHighlighted: !prevState.isReplyHighlighted
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleToggleHighlight", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(e) {
        var _this$props5, reply, contentType, replyId, isReplyHighlighted;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                e.preventDefault();
                _this$props5 = _this.props, reply = _this$props5.reply, contentType = _this$props5.contentType;
                replyId = reply.id;
                isReplyHighlighted = _this.state.isReplyHighlighted;
                _context4.next = 6;
                return (0, _utils.toggleHighlight)(Number(replyId), isReplyHighlighted, _this.onHighlightReply, contentType, _this.handleShowAlert);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x6) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "reloadOrRedirect", function () {
      var _this$props6 = _this.props,
          displayExtendedActions = _this$props6.displayExtendedActions,
          reply = _this$props6.reply;

      if (displayExtendedActions) {
        globalThis.location.reload();
      } else {
        Reply.redirectToPermalink(Number(reply.publicReplyId));
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMarkAsSpam", /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(shouldBanUser) {
        var _this$props7, reply, contentType, replyId;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$props7 = _this.props, reply = _this$props7.reply, contentType = _this$props7.contentType;
                replyId = reply.id;
                _context5.prev = 2;
                _context5.next = 5;
                return (0, _topicService.markReplyAsSpam)(contentType, Number(replyId), shouldBanUser);

              case 5:
                _this.handleShowAlert('success', 'frontend_moderation.reply_marked_as_spam');

                _this.showSpamModal(false);

                _this.reloadOrRedirect();

                _context5.next = 14;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](2);

                _this.handleShowAlert('error', 'frontend_moderation.error_marking_reply_as_spam');

                _this.showSpamModal(false);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 10]]);
      }));

      return function (_x7) {
        return _ref7.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMarkAsNotSpam", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
      var _this$props8, reply, contentType, replyId;

      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this$props8 = _this.props, reply = _this$props8.reply, contentType = _this$props8.contentType;
              replyId = reply.id;
              _context6.prev = 2;
              _context6.next = 5;
              return (0, _topicService.markReplyAsNotSpam)(contentType, Number(replyId));

            case 5:
              _this.handleShowAlert('success', 'frontend_moderation.reply_unmarked_as_spam');

              _this.showSpamModal(false);

              _this.reloadOrRedirect();

              _context6.next = 14;
              break;

            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6["catch"](2);

              _this.handleShowAlert('error', 'frontend_moderation.error_marking_reply_as_not_spam');

              _this.showSpamModal(false);

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[2, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleResolve", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
      var _this$props9, reply, contentType, replyId;

      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _this$props9 = _this.props, reply = _this$props9.reply, contentType = _this$props9.contentType;
              replyId = reply.id;
              _context7.prev = 2;
              _context7.next = 5;
              return (0, _topicService2.resolveReply)(contentType, Number(replyId));

            case 5:
              _this.handleShowAlert('success', 'Report(s) has been resolved.');

              _this.showTrashModal(false);

              _this.reloadOrRedirect();

              _context7.next = 14;
              break;

            case 10:
              _context7.prev = 10;
              _context7.t0 = _context7["catch"](2);

              _this.handleShowAlert('error', 'error');

              _this.showTrashModal(false);

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[2, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleApprove", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
      var _this$props10, reply, contentType, displayExtendedActions, replyId;

      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _this$props10 = _this.props, reply = _this$props10.reply, contentType = _this$props10.contentType, displayExtendedActions = _this$props10.displayExtendedActions;
              replyId = reply.id;
              _context8.prev = 2;
              _context8.next = 5;
              return (0, _topicService2.approveReply)(contentType, Number(replyId));

            case 5:
              _this.setState({
                isReplyPending: false
              });

              _this.handleShowAlert('success', 'Reply has been approved.');

              if (displayExtendedActions) {
                globalThis.location.reload();
              }

              _context8.next = 14;
              break;

            case 10:
              _context8.prev = 10;
              _context8.t0 = _context8["catch"](2);
              console.error('Error approving reply:', _context8.t0);

              _this.handleShowAlert('error', 'Error approving reply');

            case 14:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[2, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTrash", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
      var _this$props11, reply, contentType, replyId;

      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _this$props11 = _this.props, reply = _this$props11.reply, contentType = _this$props11.contentType;
              replyId = reply.id;
              _context9.prev = 2;
              _context9.next = 5;
              return (0, _topicService2.toggleReplyTrashed)(contentType, Number(replyId), true);

            case 5:
              _this.handleShowAlert('success', 'frontend_moderation.reply_trashed');

              _this.showTrashModal(false);

              _this.reloadOrRedirect();

              _context9.next = 14;
              break;

            case 10:
              _context9.prev = 10;
              _context9.t0 = _context9["catch"](2);

              _this.handleShowAlert('error', 'frontend_moderation.error_trashing_reply');

              _this.showTrashModal(false);

            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[2, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleRestore", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
      var _this$props12, reply, contentType, replyId;

      return _regenerator.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _this$props12 = _this.props, reply = _this$props12.reply, contentType = _this$props12.contentType;
              replyId = reply.id;
              _context10.prev = 2;
              _context10.next = 5;
              return (0, _topicService2.toggleReplyTrashed)(contentType, Number(replyId), false);

            case 5:
              _this.handleShowAlert('success', 'frontend_moderation.reply_restored');

              _this.showTrashModal(false);

              _this.reloadOrRedirect();

              _context10.next = 14;
              break;

            case 10:
              _context10.prev = 10;
              _context10.t0 = _context10["catch"](2);

              _this.handleShowAlert('error', 'frontend_moderation.error_restoring_reply');

              _this.showTrashModal(false);

            case 14:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[2, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMarkBestAnswerClick", /*#__PURE__*/function () {
      var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(e) {
        var _this$props13, reply, contentType, isBestAnswerClicked, isBestAnswer, privateReplyId, postId;

        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this$props13 = _this.props, reply = _this$props13.reply, contentType = _this$props13.contentType;
                isBestAnswerClicked = _this.state.isBestAnswerClicked;
                isBestAnswer = reply.isBestAnswer, privateReplyId = reply.id, postId = reply.publicReplyId;
                e.preventDefault();

                if (!isBestAnswerClicked) {
                  _context11.next = 7;
                  break;
                }

                e.stopPropagation();
                return _context11.abrupt("return");

              case 7:
                _context11.prev = 7;

                if (!isBestAnswer) {
                  _context11.next = 14;
                  break;
                }

                _context11.next = 11;
                return _axios.default.delete("/community/api/".concat((0, _contentType.getConsistentContentType)(contentType), "s/replies/").concat(privateReplyId, "/answer"), {
                  data: {
                    csrfToken: (0, _csrfToken.csrfToken)()
                  }
                });

              case 11:
                _this.handleShowAlert('success', 'frontend_moderation.reply_unmarked_as_best_answer');

                _context11.next = 17;
                break;

              case 14:
                _context11.next = 16;
                return _axios.default.post("/community/api/".concat((0, _contentType.getConsistentContentType)(contentType), "s/replies/").concat(privateReplyId, "/answer"));

              case 16:
                _this.handleShowAlert('success', 'frontend_moderation.reply_marked_as_best_answer');

              case 17:
                _this.setState({
                  isBestAnswerClicked: true
                });

                globalThis.location.assign(_resolveUrl((0, _absoluteUrlRuntime.resolveUrl)("".concat(globalThis.location.pathname, "/?postid=").concat(postId, "#post").concat(postId))));
                _context11.next = 24;
                break;

              case 21:
                _context11.prev = 21;
                _context11.t0 = _context11["catch"](7);

                _this.handleShowAlert('error', isBestAnswer ? 'frontend_moderation.error_unmarking_best_answer' : 'frontend_moderation.error_marking_best_answer');

              case 24:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[7, 21]]);
      }));

      return function (_x8) {
        return _ref13.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handlePinReplyClick", /*#__PURE__*/function () {
      var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(e) {
        var _this$props14, reply, contentType, isPinnedReply, replyId, postId;

        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this$props14 = _this.props, reply = _this$props14.reply, contentType = _this$props14.contentType;
                isPinnedReply = reply.isPinnedReply, replyId = reply.id, postId = reply.publicReplyId;
                e.preventDefault();
                _context12.prev = 3;

                if (!isPinnedReply) {
                  _context12.next = 10;
                  break;
                }

                _context12.next = 7;
                return (0, _topicService.unpinReply)(contentType, Number(replyId));

              case 7:
                _this.handleShowAlert('success', 'Reply is unpinned');

                _context12.next = 13;
                break;

              case 10:
                _context12.next = 12;
                return (0, _topicService.pinReply)(contentType, Number(replyId));

              case 12:
                _this.handleShowAlert('success', 'Reply is pinned');

              case 13:
                globalThis.location.assign(_resolveUrl((0, _absoluteUrlRuntime.resolveUrl)("".concat(globalThis.location.pathname, "/?postid=").concat(postId, "#post").concat(postId))));
                _context12.next = 19;
                break;

              case 16:
                _context12.prev = 16;
                _context12.t0 = _context12["catch"](3);

                _this.handleShowAlert('error', 'Something went wrong');

              case 19:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, null, [[3, 16]]);
      }));

      return function (_x9) {
        return _ref14.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCopyLink", /*#__PURE__*/function () {
      var _ref15 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(e) {
        var postId, permalink;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                postId = _this.props.reply.publicReplyId;
                e.stopPropagation();
                _context13.prev = 2;
                permalink = (0, _utils.getPermalink)(Number(postId));
                _context13.next = 6;
                return navigator.clipboard.writeText(permalink);

              case 6:
                _this.handleShowAlert('success', 'frontend_moderation.link_copied_to_clipboard');

                _context13.next = 12;
                break;

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13["catch"](2);

                _this.handleShowAlert('error', 'frontend_moderation.failed_to_copy_link_to_clipboard');

              case 12:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[2, 9]]);
      }));

      return function (_x10) {
        return _ref15.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showMoveReplyModal", function (show) {
      _this.setState({
        showMoveReplyModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMoveToTopLevel", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14() {
      var _this$props15, reply, contentType;

      return _regenerator.default.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _this$props15 = _this.props, reply = _this$props15.reply, contentType = _this$props15.contentType;
              _context14.prev = 1;
              _context14.next = 4;
              return (0, _topicService.moveToTopLevel)(contentType, Number(reply.id));

            case 4:
              window.location.href = _resolveUrl((0, _absoluteUrlRuntime.resolveUrl)((0, _utils.getPermalink)(Number(reply.publicReplyId))));
              _context14.next = 10;
              break;

            case 7:
              _context14.prev = 7;
              _context14.t0 = _context14["catch"](1);

              _this.handleShowAlert('error', 'Something went wrong');

            case 10:
              _this.showMoveReplyModal(false);

            case 11:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[1, 7]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMoveToAnotherTopic", /*#__PURE__*/function () {
      var _ref17 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(destinationTopicId, destinationContentType, title) {
        var _this$props16, reply, contentType, topicUrl, topicLink;

        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this$props16 = _this.props, reply = _this$props16.reply, contentType = _this$props16.contentType;
                _context15.prev = 1;
                _context15.next = 4;
                return (0, _topicService.moveToTopAnotherTopic)(contentType, Number(reply.id), destinationTopicId, destinationContentType);

              case 4:
                topicUrl = "".concat(globalThis.location.origin, "/").concat(destinationContentType, "s/").concat(destinationTopicId);
                topicLink = "<a href=\"".concat(topicUrl, "\">").concat(title, "</a>");

                _this.handleShowAlert('success', "The reply has been successfully moved to ".concat(topicLink));

                _this.showMoveReplyModal(false);

                _context15.next = 13;
                break;

              case 10:
                _context15.prev = 10;
                _context15.t0 = _context15["catch"](1);

                _this.handleShowAlert('error', 'Something went wrong');

              case 13:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, null, [[1, 10]]);
      }));

      return function (_x11, _x12, _x13) {
        return _ref17.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getMenuItems", function () {
      var _this$props17 = _this.props,
          reply = _this$props17.reply,
          showPostActions = _this$props17.showPostActions,
          _this$props17$canMark = _this$props17.canMarkBestAnswer,
          canMarkBestAnswer = _this$props17$canMark === void 0 ? false : _this$props17$canMark,
          unlimitedEditPermission = _this$props17.unlimitedEditPermission,
          displayReportAction = _this$props17.displayReportAction,
          displayExtendedActions = _this$props17.displayExtendedActions,
          topic = _this$props17.topic;
      var _this$state2 = _this.state,
          isReplyHighlighted = _this$state2.isReplyHighlighted,
          isReplyPending = _this$state2.isReplyPending;
      var publicReplyId = reply.publicReplyId,
          isBestAnswer = reply.isBestAnswer,
          trashed = reply.trashed,
          spam = reply.spam,
          authorId = reply.authorId,
          repliedAt = reply.repliedAt,
          reported = reply.reported,
          author = reply.author;
      var showEdit = (0, _permissions.canLoginUserEditPost)(authorId, String(publicReplyId), repliedAt, unlimitedEditPermission);

      if (displayExtendedActions) {
        var _this$config, _this$config2, _getInsidedData, _createdAt;

        var replyActionItem = [{
          title: 'Promote to new topic',
          'data-qa': 'menu-promote-to-new-topic',
          onClick: function onClick() {
            return _this.showPromoteToNewTopicModal(true);
          }
        }, {
          title: 'Move',
          'data-qa': 'menu-move',
          onClick: function onClick() {
            return _this.showMoveReplyModal(true);
          }
        }].concat((0, _toConsumableArray2.default)((_this$config = _this.config) !== null && _this$config !== void 0 && _this$config.renderSendToApp && (_this$config2 = _this.config) !== null && _this$config2 !== void 0 && _this$config2.integrationStatuses && Object.values(_this.config.integrationStatuses).some(Boolean) ? [{
          title: 'Send to app',
          'data-qa': 'menu-send-to-app',
          children: _this.config.renderSendToApp({
            publicReplyId: Number(reply.publicReplyId),
            contentType: _this.props.contentType,
            topicTitle: _this.props.topic.title,
            replyContent: reply.content || '',
            authorUsername: author.username,
            authorUserId: String(authorId),
            onShowAlert: _this.handleShowAlert
          })
        }] : []));
        var currentUserId = (_getInsidedData = (0, _insidedDataStorage.getInsidedData)('user')) === null || _getInsidedData === void 0 ? void 0 : _getInsidedData.userid;
        var userActionItems = [].concat((0, _toConsumableArray2.default)(authorId !== currentUserId ? [{
          title: 'Send message',
          'data-qa': 'menu-send-message',
          href: "/privateMessages/overview#conversation/".concat(authorId)
        }] : []), [{
          title: 'View profile',
          'data-qa': 'menu-view-profile',
          children: (0, _preact.h)(_Profile.default, {
            authorId: authorId.toString(),
            author: author,
            onShowAlert: _this.handleShowAlert
          })
        }, {
          title: 'View IP details',
          'data-qa': 'menu-view-ip-details',
          children: (0, _preact.h)(_IpDetails.default, {
            authorId: authorId.toString(),
            authorName: author.username,
            publicTopicId: topic.publicId,
            publicReplyId: reply.publicReplyId.toString()
          })
        }]);
        var authorActionItem = [{
          title: 'Send moderation notice',
          'data-qa': 'menu-send-moderation-notice',
          children: (0, _preact.h)(_NotifyAuthor.default, {
            onShowAlert: _this.handleShowAlert,
            topicId: Number(_this.props.topic.id),
            contentType: _this.props.contentType,
            id: String(reply.id),
            topicPublicId: String(_this.props.topic.publicId),
            topicTitle: _this.props.topic.title,
            publicReplyId: String(reply.publicReplyId),
            content: reply.content || '',
            authorId: String(reply.authorId),
            topicCreatedAt: (_createdAt = _this.props.topic.createdAt) !== null && _createdAt !== void 0 ? _createdAt : '',
            repliedAt: reply.repliedAt
          })
        }];
        var replyRemoveActionItem = [(0, _menuOptions.getMarkAsSpamMenuItem)(_this.showSpamModal, spam), (0, _menuOptions.getTrashMenuItem)(trashed ? _this.handleRestore : _this.showTrashModal, trashed)]; // Possible options for control

        if (trashed) {
          var trashedAction = (0, _menuOptions.getTrashMenuItem)(trashed ? _this.handleRestore : _this.showTrashModal, trashed);
          return [userActionItems, authorActionItem, [trashedAction]];
        }

        if (spam) {
          var spamAction = (0, _menuOptions.getMarkAsSpamMenuItem)(_this.showSpamModal, spam);
          return [userActionItems, authorActionItem, [spamAction]];
        }

        if (reported) {
          var resolveAction = (0, _menuOptions.getResolveMenuItem)(_this.toggleReportedContentResolveModal);
          return [[resolveAction], replyActionItem, userActionItems, authorActionItem, replyRemoveActionItem];
        }

        if (isReplyPending) {
          var approveAction = (0, _menuOptions.getApproveMenuItem)(_this.handleApprove);
          return [[approveAction], replyActionItem, userActionItems, authorActionItem, replyRemoveActionItem];
        }

        return [replyActionItem, userActionItems, authorActionItem, replyRemoveActionItem];
      }

      var isTopicClosed = 'closed' in topic ? topic.closed : false;

      if (showPostActions) {
        return [].concat((0, _toConsumableArray2.default)(canMarkBestAnswer ? [(0, _menuOptions.getBestAnswerMenuItem)(isBestAnswer, _this.handleMarkBestAnswerClick)] : []), [(0, _menuOptions.getEditMenuItem)(_this.handleEditClick), (0, _menuOptions.getHighlightReplyMenuItem)(isReplyHighlighted, _this.handleToggleHighlight), (0, _menuOptions.getCopyLinkMenuItem)(Number(publicReplyId), _this.handleShowAlert)], (0, _toConsumableArray2.default)(!isTopicClosed ? [(0, _menuOptions.getQuoteMenuItem)(function () {
          return _this.handleReplyClick(true);
        })] : []), (0, _toConsumableArray2.default)(displayReportAction ? [(0, _menuOptions.getReportMenuItem)(_this.toggleReportedContentModal)] : []), [(0, _menuOptions.getMarkAsSpamMenuItem)(_this.showSpamModal, spam), (0, _menuOptions.getTrashMenuItem)(trashed ? _this.handleRestore : _this.showTrashModal, trashed)]);
      }

      return [].concat((0, _toConsumableArray2.default)(canMarkBestAnswer ? [(0, _menuOptions.getBestAnswerMenuItem)(isBestAnswer, _this.handleMarkBestAnswerClick)] : []), (0, _toConsumableArray2.default)(!isTopicClosed ? [(0, _menuOptions.getQuoteMenuItem)(function () {
        return _this.handleReplyClick(true);
      })] : []), (0, _toConsumableArray2.default)(showEdit ? [(0, _menuOptions.getEditMenuItem)(_this.handleEditClick)] : []), [(0, _menuOptions.getCopyLinkMenuItem)(Number(publicReplyId), _this.handleShowAlert), (0, _menuOptions.getReportMenuItem)(_this.toggleReportedContentModal)]);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getActionItems", function () {
      var _this$props18 = _this.props,
          reply = _this$props18.reply,
          canMarkBestAnswer = _this$props18.canMarkBestAnswer,
          canUserPinReplies = _this$props18.canUserPinReplies;
      var isReplyHighlighted = _this.state.isReplyHighlighted;
      var isBestAnswer = reply.isBestAnswer,
          isPinnedReply = reply.isPinnedReply,
          trashed = reply.trashed,
          spam = reply.spam;
      var isTrashedOrSpamReply = trashed || spam;
      return [!isTrashedOrSpamReply ? (0, _preact.h)(_Tooltip.default, {
        position: "center",
        top: -32,
        key: "edit",
        trigger: (0, _preact.h)(_SubtleButton.default, {
          size: "medium",
          "data-qa": "action-edit",
          icon: (0, _preact.h)(_Edit.default, {
            width: 16,
            height: 16,
            fill: "#5F6C7A"
          }),
          onClick: _this.handleEditClick,
          ariaLabel: "Edit"
        }),
        customClasses: "action-menu__tooltip",
        tooltipMessage: "Edit"
      }) : null, canMarkBestAnswer && !isTrashedOrSpamReply ? (0, _preact.h)(_Tooltip.default, {
        position: "center",
        top: -32,
        key: "best-answer",
        trigger: (0, _preact.h)(_SubtleButton.default, {
          size: "medium",
          "data-qa": "action-best-answer",
          icon: isBestAnswer ? (0, _preact.h)(_CheckCircleOffOutline.default, {
            width: 16,
            height: 16,
            fill: "#5F6C7A"
          }) : (0, _preact.h)(_CheckCircleOutline.default, {
            width: 16,
            height: 16,
            fill: "#5F6C7A"
          }),
          onClick: _this.handleMarkBestAnswerClick,
          ariaLabel: isBestAnswer ? 'Unmark as answer' : 'Mark as answer'
        }),
        customClasses: "action-menu__tooltip",
        tooltipMessage: isBestAnswer ? 'Unmark as answer' : 'Mark as answer'
      }) : null, !isTrashedOrSpamReply ? (0, _preact.h)(_Tooltip.default, {
        position: "center",
        top: -32,
        key: "highlight",
        trigger: (0, _preact.h)(_SubtleButton.default, {
          size: "medium",
          "data-qa": "action-highlight",
          icon: isReplyHighlighted ? (0, _preact.h)(_HighlightOff.default, {
            width: 16,
            height: 16,
            fill: "#5F6C7A"
          }) : (0, _preact.h)(_Highlight.default, {
            width: 16,
            height: 16,
            fill: "#5F6C7A"
          }),
          onClick: _this.handleToggleHighlight,
          ariaLabel: isReplyHighlighted ? 'Unhighlight' : 'Highlight'
        }),
        customClasses: "action-menu__tooltip",
        tooltipMessage: isReplyHighlighted ? 'Unhighlight' : 'Highlight'
      }) : null, canUserPinReplies && !isTrashedOrSpamReply ? (0, _preact.h)(_Tooltip.default, {
        position: "center",
        top: -32,
        trigger: (0, _preact.h)(_SubtleButton.default, {
          size: "medium",
          "data-qa": "action-pin",
          key: isPinnedReply ? 'unpin' : 'pin',
          icon: isPinnedReply ? (0, _preact.h)(_PinOffOutline.default, {
            width: 16,
            height: 16,
            fill: "#5F6C7A"
          }) : (0, _preact.h)(_PinOutline.default, {
            width: 16,
            height: 16,
            fill: "#5F6C7A"
          }),
          onClick: _this.handlePinReplyClick,
          ariaLabel: isPinnedReply ? 'Unpin' : 'Pin'
        }),
        customClasses: "action-menu__tooltip",
        tooltipMessage: isPinnedReply ? 'Unpin' : 'Pin'
      }) : null, (0, _preact.h)(_Tooltip.default, {
        position: "center",
        top: -32,
        key: "link",
        trigger: (0, _preact.h)(_SubtleButton.default, {
          size: "medium",
          "data-qa": "action-copy-link",
          icon: (0, _preact.h)(_CopyLink.default, {
            size: 16,
            fill: "#5F6C7A"
          }),
          onClick: _this.handleCopyLink,
          ariaLabel: "Link"
        }),
        customClasses: "action-menu__tooltip",
        tooltipMessage: "Copy link"
      })];
    });
    return _this;
  }

  (0, _createClass2.default)(Reply, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      var translatedReplyContent = this.props.translatedReplyContent;
      var previousTranslatedReplyContent = previousProps.translatedReplyContent;

      if (translatedReplyContent !== previousTranslatedReplyContent) {
        this.setState({
          updatedReplyContent: translatedReplyContent
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _authorInfo$url,
          _authorInfo$name,
          _authorInfo$avatar,
          _authorInfo$signature,
          _authorInfo$name2,
          _authorInfo$userTitle,
          _this2 = this;

      var _this$props19 = this.props,
          reply = _this$props19.reply,
          _this$props19$depthLe = _this$props19.depthLevel,
          depthLevel = _this$props19$depthLe === void 0 ? 1 : _this$props19$depthLe,
          authors = _this$props19.authors,
          isTranslationInProgress = _this$props19.isTranslationInProgress,
          isAllRepliesTranslationInProgress = _this$props19.isAllRepliesTranslationInProgress,
          contentType = _this$props19.contentType,
          currentUser = _this$props19.currentUser,
          topic = _this$props19.topic,
          languageList = _this$props19.languageList,
          attachmentCdn = _this$props19.attachmentCdn,
          replyCount = _this$props19.replyCount,
          isExpanded = _this$props19.isExpanded,
          onToggleReplies = _this$props19.onToggleReplies,
          onLikeUpdate = _this$props19.onLikeUpdate,
          _this$props19$userHas = _this$props19.userHasPermissionToReply,
          userHasPermissionToReply = _this$props19$userHas === void 0 ? false : _this$props19$userHas,
          _this$props19$display = _this$props19.displayPostStatusPill,
          displayPostStatusPill = _this$props19$display === void 0 ? false : _this$props19$display,
          _this$props19$display2 = _this$props19.displayExtendedActions,
          displayExtendedActions = _this$props19$display2 === void 0 ? false : _this$props19$display2;
      var _this$state3 = this.state,
          alert = _this$state3.alert,
          showReportContentModal = _this$state3.showReportContentModal,
          showReportContentResolveModal = _this$state3.showReportContentResolveModal,
          showEditor = _this$state3.showEditor,
          isReplyEditorOpen = _this$state3.isReplyEditorOpen,
          showSpamModal = _this$state3.showSpamModal,
          showTrashModal = _this$state3.showTrashModal,
          showPromoteToNewTopicModal = _this$state3.showPromoteToNewTopicModal,
          updatedReplyContent = _this$state3.updatedReplyContent,
          updatedAttachments = _this$state3.updatedAttachments,
          isReplyHighlighted = _this$state3.isReplyHighlighted,
          isReplyPending = _this$state3.isReplyPending,
          isHovered = _this$state3.isHovered,
          showMoveReplyModal = _this$state3.showMoveReplyModal;
      var title = topic.title,
          privateId = topic.id,
          publicId = topic.publicId;
      var repliedAt = reply.repliedAt,
          authorId = reply.authorId,
          privateReplyId = reply.id,
          likedBy = reply.likedBy,
          isBestAnswer = reply.isBestAnswer,
          topLikedBy = reply.topLikedBy;
      var userId = authorId;
      var authorData = userId && authors ? authors[userId] : null;
      var isCurrentUserReply = userId === currentUser.id;
      var newAuthorData = isCurrentUserReply ? {
        id: currentUser.id,
        name: currentUser.name,
        avatar: currentUser.avatar,
        url: currentUser.url,
        rank: null,
        userLevel: undefined,
        signature: null,
        userTitle: null
      } : null;
      var authorInfo = authorData !== null && authorData !== void 0 ? authorData : newAuthorData;
      var authorUrl = displayExtendedActions ? "/member/profile?userid=".concat(userId) : (_authorInfo$url = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.url) !== null && _authorInfo$url !== void 0 ? _authorInfo$url : '';
      var author = {
        id: userId,
        name: (_authorInfo$name = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.name) !== null && _authorInfo$name !== void 0 ? _authorInfo$name : 'Anonymous',
        avatar: (_authorInfo$avatar = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.avatar) !== null && _authorInfo$avatar !== void 0 ? _authorInfo$avatar : '',
        url: authorUrl,
        rank: authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.rank,
        userLevel: authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.userLevel,
        signature: (_authorInfo$signature = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.signature) !== null && _authorInfo$signature !== void 0 ? _authorInfo$signature : null,
        userName: (_authorInfo$name2 = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.name) !== null && _authorInfo$name2 !== void 0 ? _authorInfo$name2 : '',
        userTitle: (_authorInfo$userTitle = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.userTitle) !== null && _authorInfo$userTitle !== void 0 ? _authorInfo$userTitle : ''
      };
      var showReplyAction = _common.common.isModuleActive('threadedRepliesDestination') && userHasPermissionToReply;
      var actionItems = displayExtendedActions ? this.getActionItems() : [];
      var showAuthorPill = String(userId) === String(topic.authorId);
      return (0, _preact.h)(_ConfigContext.ConfigContext.Consumer, null, function (config) {
        _this2.config = config;

        var menuItems = _this2.getMenuItems();

        return (0, _preact.h)("div", {
          className: "threaded-reply-item",
          "data-qa": "threaded-reply-item",
          onMouseEnter: _this2.handleMouseEnter,
          onMouseLeave: _this2.handleMouseLeave,
          role: "article",
          "aria-label": "Reply by ".concat(author.name),
          tabIndex: 0
        }, (0, _preact.h)(_TopicHeader.default, {
          author: author,
          timestamp: repliedAt,
          isUserLoggedIn: !!currentUser.id,
          isBestAnswer: isBestAnswer,
          menuItems: menuItems,
          showAuthorPill: showAuthorPill,
          displayPostStatusPill: displayPostStatusPill,
          isReplyHighlighted: isReplyHighlighted,
          actionsToDisplay: actionItems,
          isReplyTrashed: reply.trashed,
          isReplySpam: reply.spam,
          isReplyPinned: reply.isPinnedReply,
          isReplyReported: reply.reported,
          isReplyPending: isReplyPending,
          isNew: !topic.readByTeamAt || new Date(topic.readByTeamAt) < new Date(reply.repliedAt),
          isHovered: isHovered,
          useControlTheme: displayExtendedActions
        }), (0, _preact.h)(_ReplyBody.default, {
          reply: reply,
          isTranslationInProgress: isTranslationInProgress,
          translatedReplyContent: updatedReplyContent,
          isAllRepliesTranslationInProgress: isAllRepliesTranslationInProgress,
          languageList: languageList,
          parentTopicTitle: title,
          showEditor: showEditor,
          userSignature: (author === null || author === void 0 ? void 0 : author.signature) && (0, _preact.h)("div", {
            className: "signature"
          }, author.signature),
          editor: _this2.renderEditor({
            isEditReply: true
          }),
          attachments: updatedAttachments && updatedAttachments.length > 0 && (0, _preact.h)(_Attachments.default, {
            attachments: updatedAttachments,
            attachmentCdn: attachmentCdn
          })
        }), (0, _preact.h)(_TopicFooter.default, {
          privateReplyId: Number(privateReplyId),
          privateId: Number(privateId),
          publicId: publicId,
          likedBy: likedBy,
          contentType: contentType,
          currentUser: currentUser,
          topLikedBy: topLikedBy,
          onEditorClick: _this2.handleReplyClick,
          showReplyAction: showReplyAction,
          replyCount: replyCount,
          isExpanded: isExpanded,
          onToggleReplies: onToggleReplies,
          onLikeUpdate: onLikeUpdate
        }), showReplyAction && isReplyEditorOpen && _this2.renderEditor({
          isEditReply: false
        }), (alert === null || alert === void 0 ? void 0 : alert.message) && (0, _preact.h)(_AlertComponent.default, {
          sticky: true,
          messageType: alert.type,
          isVisibleFor: 3000,
          onTimeoutEnd: function onTimeoutEnd() {
            return _this2.setState({
              alert: undefined
            });
          }
        }, alert.message), showReportContentModal && (0, _preact.h)(_ReportContentModal.default, {
          topicTitle: title,
          topicId: Number(privateId),
          replyId: Number(privateReplyId),
          contentType: contentType,
          showReportContentModal: _this2.toggleReportedContentModal,
          userId: currentUser.id,
          onShowAlert: _this2.handleShowAlert
        }), showReportContentResolveModal && (0, _preact.h)(_ResolveModal.default, {
          reportedContent: reply.reportedContent,
          onResolve: _this2.handleResolve,
          onClose: function onClose() {
            return _this2.toggleReportedContentResolveModal(false);
          },
          topicTitle: title
        }), showSpamModal && (reply.spam ? (0, _preact.h)(_MarkAsNotSpamModal.default, {
          isOpen: showSpamModal,
          title: "frontend_moderation.mark_reply_as_not_spam_title",
          subTitle: "frontend_moderation.unspam_reply_warning",
          onClose: function onClose() {
            return _this2.showSpamModal(false);
          },
          onMarkAsNotSpam: _this2.handleMarkAsNotSpam
        }) : (0, _preact.h)(_MarkAsSpamModal.default, {
          title: "frontend_moderation.mark_reply_as_spam",
          subTitle: "frontend_moderation.spam_reply_warning",
          isOpen: showSpamModal,
          onClose: function onClose() {
            return _this2.showSpamModal(false);
          },
          onMarkAsSpam: /*#__PURE__*/function () {
            var _ref18 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(shouldBanUser) {
              return _regenerator.default.wrap(function _callee16$(_context16) {
                while (1) {
                  switch (_context16.prev = _context16.next) {
                    case 0:
                      return _context16.abrupt("return", _this2.handleMarkAsSpam(shouldBanUser));

                    case 1:
                    case "end":
                      return _context16.stop();
                  }
                }
              }, _callee16);
            }));

            return function (_x14) {
              return _ref18.apply(this, arguments);
            };
          }()
        })), showTrashModal && (0, _preact.h)(_TrashModal.default, {
          title: "frontend_moderation.trash_the_reply",
          subTitle: "frontend_moderation.trash_reply_warning",
          isOpen: showTrashModal,
          onClose: function onClose() {
            return _this2.showTrashModal(false);
          },
          onTrash: _this2.handleTrash
        }), showPromoteToNewTopicModal && (0, _preact.h)(_Moderation.PromoteReplyToNewTopicModal, {
          replyId: Number(privateReplyId),
          contentType: contentType,
          onClose: function onClose() {
            return _this2.showPromoteToNewTopicModal(false);
          },
          onShowAlert: _this2.handleShowAlert,
          getReplies: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17() {
            return _regenerator.default.wrap(function _callee17$(_context17) {
              while (1) {
                switch (_context17.prev = _context17.next) {
                  case 0:
                    return _context17.abrupt("return", globalThis.location.reload());

                  case 1:
                  case "end":
                    return _context17.stop();
                }
              }
            }, _callee17);
          }))
        }), showMoveReplyModal && (0, _preact.h)(_MoveReplyModal.default, {
          isOpen: showMoveReplyModal,
          onClose: function onClose() {
            return _this2.showMoveReplyModal(false);
          },
          onMoveToTopLevel: _this2.handleMoveToTopLevel,
          onMoveToTopAnotherTopic: _this2.handleMoveToAnotherTopic,
          allowMoveToMainThread: depthLevel > 1,
          isLoading: false
        }));
      });
    }
  }]);
  return Reply;
}(_preact.Component);

(0, _defineProperty2.default)(Reply, "redirectToPermalink", function (postId) {
  globalThis.location.href = (0, _absoluteUrlRuntime.resolveUrl)((0, _utils.getPermalink)(Number(postId)));
});

var _default = (0, _HubAI.withOnDemandTranslationProps)(Reply, ['isTranslationInProgress', 'languageList', 'onDisplayOriginal', 'isPostTranslated']);

exports.default = _default;
var cssAnchorName = 'topic-reply';
exports.cssAnchorName = cssAnchorName;